import { Component, Input } from '@angular/core';

@Component({
	selector: '',
	template: ''
})
export class SnQuillViewComponent {
	@Input() content: string;
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=os2z8rc99lf!./shared/components/common/sn-quill-view/sn-quill-view.ts